import { kitIndexValidate } from '../../application/dtos/kit_index_validate';

export class kitIndexEntity {
    constructor( { id, sku, description, client_name, included_products_count } ){
        this.id = id;
        this.sku = sku;
        this.description = description;
        this.client_name = client_name;
        this.included_products_count = included_products_count;
    }

    isValid() {
        return kitIndexValidate(this);
    }
}